import { css } from "@emotion/react";
import { fontSizes, fontWeights, gutterSizes, lineHeights } from "@gumtree/ui-library/src/base/theme";
import React from "react";

const StyledListTitleStyle = css`
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.medium};
    margin-bottom: ${gutterSizes.base};
`;

export const StyledListTitle = ({children, ...props}: React.PropsWithChildren) => {
    return (<div css={StyledListTitleStyle} {...props}>
        {children}
    </div>);
}
